import {RepoIcon} from '@primer/octicons-react'
import {useRef} from 'react'

import {isRepository} from '../utils/copilot-chat-helpers'
import {useChatState} from '../utils/CopilotChatContext'
import {TopicIndicatorFlash} from './TopicIndicatorFlash'

export function TopicIndicator() {
  const {currentTopic} = useChatState()

  const removeButtonRef = useRef<HTMLButtonElement>(null)

  const repo = isRepository(currentTopic) ? currentTopic : undefined

  if (!repo) return null

  return <TopicIndicatorFlash icon={<RepoIcon />} repo={repo} removeButtonRef={removeButtonRef} />
}

try{ TopicIndicator.displayName ||= 'TopicIndicator' } catch {}